// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getInvoicePayment } from "@adl/App/Services/InvoicePaymentService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface GetInvoicePaymentApiParameter extends ApiParameter {
    id: string;
}

export interface InvoicePaymentModel {
    referenceId: string;
    isCreditCardPayment: string;
    date: string;
    totalAmount: string;
    cardNumber: string;
    cardType: string;
    paymentMethodName: string;
    invoices: string;
    customerComment: string;
}

type HandlerType = ApiHandler<GetInvoicePaymentApiParameter, InvoicePaymentModel>;

export const DispatchBeginLoadInvoicePayment: HandlerType = props => {
    props.dispatch({
        type: "Data/InvoicePayment/BeginLoadInvoicePayment",
        id: props.parameter.id,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getInvoicePayment(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/InvoicePayment/FailedToLoadInvoicePayment",
                id: props.parameter.id,
                status: 404,
            } as any);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadInvoicePayment: HandlerType = props => {
    props.dispatch({
        type: "Data/InvoicePayment/CompleteLoadInvoicePayment",
        invoicePayment: props.apiResult,
    } as any);
};

export const chain = [
    DispatchBeginLoadInvoicePayment,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadInvoicePayment,
];

const loadInvoicePayment = createHandlerChainRunner(chain, "LoadInvoicePayment");
export default loadInvoicePayment;
